import { buildCameraTargets } from './buildCameraTargets'

// utils/initISTCameraSession.js
export function initISTCameraSession({ moduleID, subType, totalQuestion }) {
  const key = `camera:ist:${moduleID}:${subType}`
  const existing = localStorage.getItem(key)
  if (existing) return JSON.parse(existing)

  const layout = 9
  const targets = buildCameraTargets(totalQuestion, layout)

  const session = {
    moduleID,
    subType,
    layout,
    targets,
    captured: [],
    totalQuestion,
    createdAt: new Date().toISOString(),
  }

  localStorage.setItem(key, JSON.stringify(session))
  return session
}
